import { PureComponent } from 'react';

import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/standard-button';

import { publishUiEvent } from 'src/utils/analytics/publish';

import messages from './clone-button.i18n';

type Props = {
  onOpenCloneDialog?: () => void;
  repositoryUuid: string;
  workspaceUuid: string;
};

export default class CloneButton extends PureComponent<Props> {
  onOpenDialog = () => {
    publishUiEvent({
      source: 'repository',
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'cloneRepositoryButton',
      objectType: 'repository',
      objectId: this.props.repositoryUuid,
      containerType: 'workspace',
      containerId: this.props.workspaceUuid,
      attributes: {
        frontbucketView: true,
      },
    });

    if (this.props.onOpenCloneDialog) {
      this.props.onOpenCloneDialog();
    }
  };

  render() {
    const buttonText = <FormattedMessage {...messages.cloneAction} />;

    if (!this.props.repositoryUuid) {
      return <Button isDisabled>{buttonText}</Button>;
    }

    return <Button onClick={this.onOpenDialog}>{buttonText}</Button>;
  }
}
